interface Props {
  color?: string
  className?: string
}

export default function FunIcon({ color = '#CCFF00', className }: Props) {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16.5938 6.04688C20.4375 6.04688 23.5781 8.95312 24.0469 12.7031C24.1406 13.1719 23.7188 13.5938 23.25 13.5469L17.4844 12.9844C17.8594 14.0625 18.0938 15.2812 18.0938 16.5938C18.0938 20.4375 15.1875 23.5781 11.4375 24.0469C10.9688 24.1406 10.5469 23.7188 10.5938 23.25L11.1562 17.4844C10.0781 17.8594 8.85938 18.0469 7.54688 18.0469C3.70312 18.0469 0.5625 15.1875 0.09375 11.4375C0 10.9688 0.421875 10.5 0.890625 10.5938L6.65625 11.1562C6.28125 10.0781 6.09375 8.85938 6.09375 7.54688C6.09375 3.70312 8.95312 0.5625 12.7031 0.09375C13.1719 0 13.6406 0.421875 13.5469 0.890625L12.9844 6.65625C14.0625 6.28125 15.2812 6.04688 16.5938 6.04688ZM12.0938 13.5469C12.8906 13.5469 13.5938 12.8906 13.5938 12.0469C13.5938 11.25 12.8906 10.5469 12.0938 10.5469C11.25 10.5469 10.5938 11.25 10.5938 12.0469C10.5938 12.8906 11.25 13.5469 12.0938 13.5469Z"
        fill={color}
      />
    </svg>
  )
}
